import React, { useState } from "react";
import { resetPassword } from "@shared/api/auth";
import { useQuery } from "@shared/hooks";
import { Button } from "@shared/components/Button";
import { Link } from "react-router-dom";
import { TextField } from "./TextField";

export const ResetPasswordForm = () => {
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<Record<string, string[]>>();
	const [done, setDone] = useState<boolean>(false);
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const query = useQuery();

	const handleReset = async () => {
		if (password !== password2) {
			setErrors({ password2: ["Passwords don't match"] });
			return;
		}
		const token = query.get("token") as string;
		setErrors(undefined);
		setLoading(true);
		const res = await resetPassword(token, password);
		setLoading(false);
		if (!res.ok) {
			setErrors(res.errors);
			return;
		}
		setDone(true);
	};

	return (
		<div className={"flex flex-col w-64"}>
			<div className={"flex flex-col mb-4"}>
				<TextField
					label={"Password"}
					type={"password"}
					value={password}
					onChange={setPassword}
					tabIndex={1}
					errors={errors?.["password"]}
				/>
				<TextField
					label={"Repeat Password"}
					type={"password"}
					placeholder={"Password"}
					value={password2}
					onChange={setPassword2}
					tabIndex={2}
					errors={errors?.["password2"]}
				/>
				{errors?.["token"]?.map((e) => (
					<div className={"text-red-400 text-xs"} key={e}>
						{e}
					</div>
				))}
				{done && (
					<div className={"text-green-400"}>Your password has been reset.</div>
				)}
			</div>

			<div className={"flex justify-between items-center"}>
				{done && <>
					<Link to={"/login"} className={"text-slate-200"}>
						Login
					</Link>
				</>}
				{!done && <>
					{!loading &&
						<Button className={"px-6"} onClick={handleReset}>
							Reset Password
						</Button>
					}
					{loading && <div className={"text-slate-200"}>Loading...</div>}
					<div>
						<Link to={"/"} className={"text-slate-200"}>
							Back
						</Link>
					</div>
				</>}
			</div>
		</div>
	);
};
